import script from "./detailsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./detailsView.vue?vue&type=script&setup=true&lang=ts"

import "./detailsView.vue?vue&type=style&index=0&id=4d6a61b6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d6a61b6"]])

export default __exports__